module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-learntec-5ae7cf8f98900dcae680893f6c42645a.png";